import React from 'react';
import ModalFormUI from './../../../widgets/form/ModalFormUI';
import InputTextSF from './../../../widgets/form/InputTextSF';
import InputNameSF from './../../../widgets/form/InputNameSF';
import InputPhoneNumberUI from './../../../widgets/form/InputPhoneNumberUI';

const UserContactUpdateModalUI = ({
    context, successMsg, errorList,
    // modes
    updateMode, submitted,
    // event handlers
    onSubmit, onCancelClick, setErrorList,
    // phoneNumber attributes and methods
    phoneNumber, onPhoneNumberChange, phoneNumberError, setPhoneNumberError,
    // email attributes and methods
    email, onEmailChange, emailError, setEmailError,
    //state attributes and methods
    state, onStateChange, stateError, setStateError,
    //pinCode attributes and methods
    pinCode, onPinCodeChange, pinCodeError, setPinCodeError,
    //address attributes and methods
    address, onAddressChange, addressError, setAddressError
}) =>
    <ModalFormUI
        context={context}
        successMsg={successMsg}
        errorList={errorList}
        titleLabel='Update User Contact'
        buttonLabel='Update'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputPhoneNumberUI name='phoneNumber' required={true}
            label='Phone Number'
            value={phoneNumber} onChange={onPhoneNumberChange}
            error={phoneNumberError}
            setError={setPhoneNumberError}
        />

        <InputTextSF type='text' name='email' required={true} maxLength={64}
            label='Email'
            value={email} onChange={onEmailChange}
            error={emailError}
            setError={setEmailError}
        />

        <InputTextSF type='text' name='state' required={true} maxLength={64}
            label='State'
            value={state} onChange={onStateChange}
            error={stateError}
            setError={setStateError}
        />

        <InputTextSF type='text' name='pinCode' required={true} maxLength={64}
            label='Pin Code'
            value={pinCode} onChange={onPinCodeChange}
            error={pinCodeError}
            setError={setPinCodeError}
        />

        <InputTextSF type='text' name='address' required={true}
            label='Address'
            value={address} onChange={onAddressChange}
            error={addressError}
            setError={setAddressError}
        />

    </ModalFormUI>

export default UserContactUpdateModalUI;
